import { api } from 'domains/api';
import { getProxyAPIRoute, PROXY_API_ROUTES } from 'domains/api/proxy/routes';
import {
  CreateSignupV4LeadPayload,
  PartialSignupLeadV4,
  SignupLeadProgressV4,
  SignupLeadV4,
  CreateSignupV4InsuranceLeadPayload,
} from 'domains/signupv4/Leads/types';

export type CreateLeadResponseV4 = Pick<SignupLeadV4, 'id' | 'schedulingId'>;

export type UpsertInsuranceLeadResponseV4 = Pick<SignupLeadV4, 'id'>;

export const createSalesforceLead = (payload: CreateSignupV4LeadPayload) => {
  return api.proxy.post<CreateLeadResponseV4>(getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads.v2), payload);
};

export const upsertSalesforceInsuranceLead = (payload: CreateSignupV4InsuranceLeadPayload) => {
  return api.proxy.post<UpsertInsuranceLeadResponseV4>(getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads.insurance), payload);
};

export const updateSalesforceLead = (payload: PartialSignupLeadV4) => {
  return api.proxy
    .put<CreateLeadResponseV4>(getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads.base), payload)
    .then(response => {
      return response.id;
    });
};

export const getSalesforceLead = (leadID: string) => {
  return api.proxy.get<SignupLeadProgressV4>(
    getProxyAPIRoute(PROXY_API_ROUTES.salesforce.leads[':leadID'].progress, { leadID }),
  );
};
